import { Apple } from "lucide-react";

/**
 * App store / Play store badges. BRep is a live platform.
 * Pass a real store URL via href to enable.
 */
export default function AppBadge({ store = "ios", href = "#" }) {
  const isIos = store === "ios";
  const label = isIos ? "App Store" : "Google Play";
  const secondary = isIos ? "Download on the" : "Get it on";

  return (
    <a
      href={href}
      target={href.startsWith("http") ? "_blank" : undefined}
      rel={href.startsWith("http") ? "noreferrer" : undefined}
      className="inline-flex items-center gap-4 px-6 py-4 border border-white/25 hover:border-[#2A5BFF] transition-colors"
      data-testid={`app-badge-${store}`}
    >
      {isIos ? <Apple size={28} /> : <PlayIcon />}
      <span className="text-left">
        <span className="block text-[10px] tracking-[0.28em] uppercase text-white/50">{secondary}</span>
        <span className="block font-anton uppercase text-xl">{label}</span>
      </span>
    </a>
  );
}

const PlayIcon = () => (
  <svg viewBox="0 0 24 24" width="26" height="26" fill="currentColor" aria-hidden="true">
    <path d="M3.5 3.06v17.88c0 .77.83 1.24 1.5.85l14.14-8.94a1 1 0 0 0 0-1.7L5 2.21c-.67-.4-1.5.08-1.5.85z" />
  </svg>
);
